interface IOpenEyeProps {
  width?: number;
  height?: number;
}

function OpenEye({ width = 28, height = 22 }: IOpenEyeProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 28.112 21.588">
      <g
        data-name="Icons / Line / Eye Open"
        transform="translate(1.056 .838)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}>
        <path d="M10.907 5.151L10.259 0" />
        <path
          data-name="Path"
          d="M6.911 6.425L4.536 1.833M3.256 9.083L0 5.151M15.093 5.151L15.741 0M19.089 6.425l2.375-4.592M22.744 9.083L26 5.151"
        />
        <ellipse cx={3.806} cy={3.974} rx={3.806} ry={3.974} transform="translate(9.194 8.52)" />
        <path
          data-name="Path"
          d="M.735 12.493S4.535 4.986 13 4.986s12.265 7.507 12.265 7.507-3.8 7.506-12.265 7.506S.735 12.493.735 12.493z"
        />
      </g>
    </svg>
  );
}

export default OpenEye;
